import React from "react";
import cloud_service from "../../assets/images/homePage/cloud_service.png";
import { Col, Container, Row } from "react-bootstrap";
import check_mark from '../../assets/images/homePage/check_mark.png';
import web_development from '../../assets/images/homePage/web_development.png';

function Service() {
  const cloudServices1 = ["Cloud Databases", "File Backups", "File Storage", "Email Services"];
  const cloudServices2 = ["Web Hosting", "AWS service", "Remote Desktop", "Hybrid cloud"];
  
  const webServices1 = ["Responsive Design", "Application Development", "React Development", "Technical support"];
  const webServices2 = ["UX/UI Design", "Web Development", "Angular Development", "Remote Desktop"];

  return (
    <section>
      <div className="service_area bg_color2" style={{ paddingTop: '70px', paddingBottom: '70px', background: 'var(--bg-light)' }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={{ span: 6, order: 1 }} sm={{ span: 12, order: 2 }} className="d-flex align-items-center justify-content-center">
              <div className="single_service_inner_thumb" data-aos="fade-right">
                <img src={cloud_service} alt="Cloud Service" className="img-fluid rounded-4 shadow-lg" />
              </div>
            </Col>
            <Col lg={{ span: 6, order: 2 }} sm={{ span: 12, order: 1 }}>
              <div className="section_title text_left mb-5">
                <div className="section_main_title" data-aos="fade-up">
                  <h1 className="fw-bold mb-3 display-4">Cloud<br /><span className="gradient-text">Services</span></h1>
                </div>
                <div className="section_content_text pt-2" data-aos="fade-up" data-aos-delay="100">
                  <p className="lead text-muted">
                    Build secure, scalable and world-class enterprise web applications that grow with your business on the cloud.
                  </p>
                </div>
              </div>
              <Row>
                <Col lg={6} sm={6} md={6}>
                  {cloudServices1.map((service, index) => (
                    <div className="modern-card p-3 mb-3 d-flex align-items-center gap-3" data-aos="fade-up" data-aos-delay={100 + index * 50} key={index}>
                      <img src={check_mark} style={{ width: '25px', height: '25px' }} alt="Check Mark" />
                      <h4 className="mb-0 fs-5 text-dark fw-semibold">{service}</h4>
                    </div>
                  ))}
                </Col>
                <Col lg={6} sm={6} md={6}>
                  {cloudServices2.map((service, index) => (
                    <div className="modern-card p-3 mb-3 d-flex align-items-center gap-3" data-aos="fade-up" data-aos-delay={200 + index * 50} key={index}>
                      <img src={check_mark} style={{ width: '25px', height: '25px' }} alt="Check Mark" />
                      <h4 className="mb-0 fs-5 text-dark fw-semibold">{service}</h4>
                    </div>
                  ))}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      
      <div className="service_area style2 py-5" style={{ background: '#ffffff' }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={{ span: 6, order: 1 }} sm={{ span: 12, order: 2 }}>
              <div className="section_title text_left mb-5">
                <div className="section_main_title" data-aos="fade-up">
                  <h1 className="fw-bold mb-3 display-4">Web <br /><span className="gradient-text">Development</span></h1>
                </div>
                <div className="section_content_text pt-2" data-aos="fade-up" data-aos-delay="100">
                  <p className="lead text-muted">
                    Centillion offers end-to-end web application development
                    services by building secure, high-performance, intuitive
                    and best-in-class platforms, web applications and products
                    utilizing latest technology and tools to address the
                    requirements of your enterprise or startups.
                  </p>
                </div>
              </div>
              <Row>
                <Col md={6} lg={6}>
                  {webServices1.map((service, index) => (
                    <div className="modern-card p-3 mb-3 d-flex align-items-center gap-3" data-aos="fade-up" data-aos-delay={100 + index * 50} key={index}>
                      <img src={check_mark} style={{ width: '25px', height: '25px' }} alt="Check Mark" />
                      <h4 className="mb-0 fs-5 text-dark fw-semibold">{service}</h4>
                    </div>
                  ))}
                </Col>
                <Col md={6} lg={6}>
                  {webServices2.map((service, index) => (
                    <div className="modern-card p-3 mb-3 d-flex align-items-center gap-3" data-aos="fade-up" data-aos-delay={200 + index * 50} key={index}>
                      <img src={check_mark} style={{ width: '25px', height: '25px' }} alt="Check Mark" />
                      <h4 className="mb-0 fs-5 text-dark fw-semibold">{service}</h4>
                    </div>
                  ))}
                </Col>
              </Row>
            </Col>
            <Col lg={{ span: 6, order: 2 }} sm={{ span: 12, order: 1 }} className="d-flex align-items-center justify-content-center">
              <div className="single_service_inner_thumb" data-aos="fade-left">
                <img src={web_development} alt="Web Development" className="img-fluid rounded-4 shadow-lg" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default Service;
